module.exports = __webpack_public_path__ + "static/media/em-37.518c4e4a.png";